import { db } from "../firebase";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { langNgheFirestore } from "../lib/langNgheFirestore";
import { kiemTraThongTinVuon } from "../lib/thongTinVuon";

const vuonCol = () => collection(db, "vuon");

export const vuonApi = {
  async danhSachTatCa() {
    const snap = await getDocs(vuonCol());
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  langNgheDanhSach(onChange, onError) {
    return langNgheFirestore(vuonCol(), { onChange, onError });
  },

  async theoChuVuon(maChuVuon) {
    const snap = await getDocs(query(vuonCol(), where("maChuVuon", "==", maChuVuon)));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  langNgheTheoChuVuon(maChuVuon, onChange, onError) {
    if (!maChuVuon) {
      onChange([]);
      return () => {};
    }
    return langNgheFirestore(query(vuonCol(), where("maChuVuon", "==", maChuVuon)), {
      onChange,
      onError,
    });
  },

  async chiTiet(id) {
    const snap = await getDoc(doc(db, "vuon", id));
    if (!snap.exists()) throw new Error("Không tìm thấy vườn");
    return { id: snap.id, ...snap.data() };
  },

  langNgheChiTiet(id, onChange, onError) {
    if (!id) {
      onChange(null);
      return () => {};
    }
    return langNgheFirestore(doc(db, "vuon", id), { onChange, onError });
  },

  async taoMoi(raw) {
    const daKiem = kiemTraThongTinVuon(raw);
    const { maChuVuon, tenVuon, tinh, xa, ...rest } = daKiem;
    const data = {
      maChuVuon,
      tenVuon,
      tinh,
      xa,
      giongBo: rest.giongBo ?? [],
      thon: rest.thon ?? null,
      diaChiChiTiet: rest.diaChiChiTiet ?? null,
      dienTichHa: daKiem.dienTichHa,
      namBatDauTrong:
        rest.namBatDauTrong != null && rest.namBatDauTrong !== ""
          ? Number(rest.namBatDauTrong)
          : null,
      soCay: rest.soCay != null && rest.soCay !== "" ? Number(rest.soCay) : null,
      maSoVungTrong: rest.maSoVungTrong ?? null,
      chungNhan: rest.chungNhan ?? [],
      ghiChu: rest.ghiChu ?? null,
      createdAt: new Date().toISOString(),
    };

    const ref = await addDoc(vuonCol(), data);
    return { id: ref.id, ...data };
  },

  async capNhat(id, raw) {
    const daKiem = kiemTraThongTinVuon({ ...raw });
    const { id: _idBo, createdAt: _createdAt, ...payload } = daKiem;
    await updateDoc(doc(db, "vuon", id), {
      ...payload,
      dienTichHa: daKiem.dienTichHa,
    });
    return vuonApi.chiTiet(id);
  },
};
